module.exports = {"meta":"Datenschutzerklärung"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/disclaimer.json
// module id = gM5x
// module chunks = 1